"use client";

import { getUserPaidSubscriptions } from "@/data/v2/client/user/paid-subscriptions";
import { paidSubscriptionKeys } from "@punchup/data/hooks/paidSubscriptionKeys";
import { useQuery } from "@tanstack/react-query";

export function useUserPaidSubscriptions(params?: { active?: boolean }) {
  return useQuery({
    queryKey: paidSubscriptionKeys.list(params),
    queryFn: () => getUserPaidSubscriptions(params),
    staleTime: 30_000,
  });
}
